import React, { useEffect } from "react";
  import { connect } from "react-redux";
  import { Container, Dropdown, Accordion, Card, Button, Form } from "react-bootstrap";
  import BootstrapTable from "react-bootstrap-table-next";
  import { resolve, reject } from "q";
  import { ToastContainer, toast } from "react-toastify";
  import { CustomerService } from "../Common/Services/CustomerService";
  import  Customerorderslideout  from './Customerorderslideout';
  import { ShippingSlideout } from './ShippingSlideout';
  import { Utils } from "../Common/Utilis";
  import _ from "lodash";
  import paginationFactory from 'react-bootstrap-table2-paginator';
  import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
  import createDOMPurify from "dompurify";
  import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
  import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
  import { FaCircle, FaEllipsis } from "react-icons/fa6";
  import moment from "moment";
  import { SingleDropdownListWithoutSearch } from "../Common/Components/SingleDropdownListWithoutSearch";
  //import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
  import 'react-tabs/style/react-tabs.css';
  import chevronRight from "../Common/Assets/Images/icons/bx-chevron-right.svg";
  import Col from 'react-bootstrap/Col';
  import Nav from 'react-bootstrap/Nav';
  import Row from 'react-bootstrap/Row';
  import Tab from 'react-bootstrap/Tab';

  const { SearchBar } = Search;
  const DOMPurify = createDOMPurify(window);

  export class Customerorder extends React.Component<any, any> {
    
    private searchTimeout: ReturnType<typeof setTimeout> | null = null;
    isSearchCleared = false; 
    constructor(props: any) {
      super(props);
      this.bindfilter = this.bindfilter.bind(this);
      this.handleSearch = this.handleSearch.bind(this);
      this.searchTimeout = null; // Store timeout reference
      this.state = {
        searchQuery: "",   // Ensure searchQuery starts as an empty string
        searchActive: "",
        searchShipped: "",
        activeTab: this.props.taboption ? this.props.taboption : "first",
        originalData: [] ,  // Store original data
        footershow: false,
        isstatus: true,
        isorderdate: true,
        iscustomername: true,
        iscustomercode: true,
        iscustomerpo: true,
        htmlItem: [],
        htmlErrorItem: [],
        htmlWarningItem: [],
        searcResult: [],
        shippingResult: [],
        shippedResult: [],
        orderid: 0,
        shipmentId: 0,
        jobIds: [],
        selectedcolumn: "All",
        selectOptions: [
          {

            id: 'All', name: 'All'
          },
            {

            id: 'Order No', name: 'Order No'
          },
          {

            id: 'Customer PO', name: 'Customer PO'
          },
          { id: 'Customer Code', name: 'Customer Code' },
          { id: 'Customer Name', name: 'Customer Name' },
          { id: 'Order Date', name: 'Order Date' },
          { id: 'Due Date', name: 'Due Date' },
          { id: 'Status', name: 'Status' },
          { id: 'Part no', name: 'Part No' },
          { id: 'Part name', name: 'Part Description' },
          // { id: 'Job desc', name: 'Job Description' },

        
          { id: 'Shipment No', name: 'Shipment No' },
          { id: 'Invoice No', name: 'Invoice No' },
          { id: 'Tracking No' , name: 'Tracking No' },
          { id: 'Job No' , name: 'Job No' },  
          { id: 'Process Name' , name: 'Process Name' },

        ],
      };
    }

    componentDidMount() {
      this.getCustomerItems();
      this.getShippingItems();
      this.getShippedItems();
    }


    
    componentDidUpdate(prevProps, prevState) {
      if (prevState.searchQuery !== this.state.searchQuery) {
          console.log("Search Query Updated:", this.state.searchQuery);
      }
      if (prevProps.locationId != this.props.locationId && !this.state.showSlideout) {
        this.getCustomerItems();
        this.getShippingItems();
        this.getShippedItems(); 
      }
  }



    getCustomerItems() {
      CustomerService.GetCustomerOrder()
        .then(async (result: any[] | null) => {
          if (result != null) {
            // console.log(result);
            this.setState({ searcResult: result, originalData: result }, () => {
              this.bindfilter();
            });
          }
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });
    }

    getShippingItems() {
      CustomerService.GetCustomerShipping()
        .then(async (result: any[] | null) => {
          if (result != null) {
            // console.log(result);
            this.setState({ shippingResult: result }, () => {
              this.bindfilter();
            });
          }
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });
    }

    getShippedItems() {
      CustomerService.GetCustomerShipped()
        .then(async (result: any[] | null) => {
          if (result != null) {
            // console.log(result);
            this.setState({ shippedResult: result }, () => {
              this.bindfilter();
            });
          }
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });
    }


    shownewslideout = () => {
      this.setState({ showSlideout: true, orderid: 0, isSpinner: false, });
    };

    showslideout = () => {
      this.setState({ showSlideout: true, isSpinner: false, });
    };


    showShippingslideout = (row: any) => {

      if (this.state.shippingResult.filter((x) => x.selected === true && x.orderID === row.orderID).length === 0) {
        // alert('Please select jobs to ship under this order');
        // return;

        toast.error('Please select jobs to ship under this order');
        reject();
        return;
      }
      this.setState({
        showShippingSlideout: true, orderid: row.orderID,
        shipmentId: 0,
        jobIds: this.state.shippingResult.filter(x => x.selected === true && x.orderID === row.orderID).map(r => r.jobId),
        isSpinner: false,
        footershow:false
      });
    };

    closeSlideOut = () => {
      this.setState({ showSlideout: false, isSpinner: false, });
      if(!this.state.searchQuery){
      this.getCustomerItems();
      this.getShippingItems();
      this.getShippedItems();
      }
      this.handleSearch(this.state.searchQuery);
    };

    closeShippingSlideOut = () => {
      this.setState({ showShippingSlideout: false, isSpinner: false, footershow:false });
      if(!this.state.searchQuery){
      this.getCustomerItems();
      this.getShippingItems();
      this.getShippedItems();
      }
      this.handleSearch(this.state.searchQuery);
    };

    rowEvents = {


      onClick: (e: any, row: any, rowIndex: any) => {
        
        if (row.rowType === undefined) {

          if (row.shipmentNo !== undefined && row.shipmentNo.length > 0) {
            this.setState({
              showShippingSlideout: true, orderid: row.orderId,
              shipmentId: row.id,
              isSpinner: false,
            });

          }
          else
            this.setState({
              showSlideout: true, orderid: row.orderID, shipmentId: 0, isSpinner: false,
            });

        }

      },
    };

    bindfilter = () => {
      let selectOptions = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.selectOptions))
      );

      this.setState({ selectOptions: selectOptions });

    };

    handleSelectedItem1 = (control: any, id: any) => {
      const columnNames = [
          "Status", "Order Date", "Customer Name", "Customer Code",
          "Customer PO", "Part No", "Part Name", "Shipment No", "Tracking No"
      ];

      const isAll = id === "All";
      
      const columnState = columnNames.reduce((acc, column) => {
          acc[`is${column.replace(/\s+/g, "").toLowerCase()}`] = isAll || id === column;
          return acc;
      }, {} as Record<string, boolean>);

      this.setState(
          { searcResult: [], selectedcolumn: id, ...columnState },
          () => this.handleSearch(this.state.searchQuery)
      );
  };


    Shippingslideoutshow = () => {
      this.setState({
        showShippingSlideout: true ,
        shipmentId: 0,
        isSpinner: false,
        footershow: false
      });
    };

    discard = () => {
    this.setState({footershow:false});
      this.getCustomerItems();
      this.getShippingItems();
      this.getShippedItems();
    };

    handleOnSelect = (row, isSelect) => {


      let shippingResult = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.shippingResult))
      );

      let listItem = shippingResult.filter(
        (x) => x.rowId === row.rowId
      );

      listItem[0].selected = isSelect;
      let selectedJobIds = shippingResult.filter(item => item.selected === true).map(item => item.jobId);
      // console.log("listitem",listItem,shippingResult);
      this.setState({ shippingResult: shippingResult , footershow : selectedJobIds.length > 0 ? true : false, orderid : listItem[0].orderID, jobIds : selectedJobIds}, () => { this.setState({ shippingResult: this.state.shippingResult }); });



    };

    handleOnSelectAll = (isSelect, rows) => {

      const ids = rows.map(r => r.rowId);
      let shippingResult = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.shippingResult))
      );

      let listItems = shippingResult.filter(
        (x) => ids.includes(x.rowId)
      );

      if (listItems.length > 0) {
        listItems.forEach((element: any, index: any) => {
          element.selected = isSelect;
        });
      };
      // console.log("yooo",ids,shippingResult,listItems,rows);

      this.setState({ shippingResult: shippingResult , jobIds : listItems.map((item: any) => item.jobId),orderid:listItems[0].orderID , footershow: (listItems.length > 0 && listItems[0].selected == true ) ? true :false});
    };

  //   handleSearch = (searchText) => {
  //     // debugger;
  //     console.log("Search text:", searchText); 

  //     // Ensure state updates before checking conditions
  //     this.setState({ searchQuery: searchText });

  //     if (searchText.trim() === "") {
  //       if (this.searchTimeout) {
  //         clearTimeout(this.searchTimeout);
  //     }
  //         console.log("Resetting search results to original data",this.state.originalData);
  //         this.setState({ searcResult: this.state.originalData });
  //         return;
  //     }

  //     if (searchText.length < 3) {
  //       this.setState({ searcResult: this.state.originalData });
  //         console.log("Search text too short, returning early");
  //         return;
  //     }

  //     if (this.searchTimeout) {
  //         clearTimeout(this.searchTimeout);
  //     }

    
  //     // Ensure 'id' gets a value from state or props
  //     let columnselcted = this.state.selectedcolumn || "All"; // Example: Ensure it has a value

    

  //     // debugger;
  //     this.searchTimeout = setTimeout(() => {
  //       let request = {
  //         searchText: searchText,  // Assign search text
  //         selectedColumns: columnselcted      // Assign selected column
  //     };

  //         console.log("Calling API with request:", request);

  //         CustomerService.GetCustomerOrderSearch(request)
  //             .then((result) => {
  //                 if (result) {
  //                     console.log("API response:", result);
  //                     this.setState({ searcResult: result });
  //                 }
  //             })
  //             .catch((err) => {
  //                 console.error("Server Error:", err);
  //                 toast.error(`Server Error: ${err}`);
  //             });
  //     }, 500);
  // };

handleSearch = (searchText) => {
  console.log("Search text:", searchText);

  this.setState({ searchQuery: searchText });

  if (this.searchTimeout) {
    clearTimeout(this.searchTimeout);
  }

  const trimmedText = searchText.trim();

  if (trimmedText === "") {
    this.isSearchCleared = true; 
    console.log("Search cleared, resetting to original data");
    this.setState({ searcResult: this.state.originalData });
    return;
  }

  if (trimmedText.length < 3) {
    this.isSearchCleared = true; 
    console.log("Search text too short, resetting to original data");
    this.setState({ searcResult: this.state.originalData });
    return;
  }

  this.isSearchCleared = false; 

  const columnselcted = this.state.selectedcolumn || "All";

  this.searchTimeout = setTimeout(() => {
    const request = {
      searchText: searchText,
      selectedColumns: columnselcted,
    };

    console.log("Calling API with request:", request);

    CustomerService.GetCustomerOrderSearch(request)
      .then((result) => {
        if (this.isSearchCleared) {
          this.setState({ searcResult: this.state.originalData });
          return;
        }

            if (result && result.length > 0) {
          const allReceiving = result.every((x) => x.status === "Active");
          const allCompleted = result.every((x) => x.status === "Shipped");

          let newActiveTab = "first"; 

          if (allReceiving) newActiveTab = "second";
          else if (allCompleted) newActiveTab = "third";

          this.setState({
            searcResult: result,
            activeTab: newActiveTab, 
          });
        }

        this.setState({ searcResult: result });
      })
      .catch((err) => {
        if (this.isSearchCleared) return;
        toast.error(`Server Error: ${err}`);
      });
  }, 500);
};





  onChangeHandler = (e) => {
    const searchText = e.target.value;
    this.setState({ searchQuery: searchText });
    this.handleSearch(searchText); // Calls the debounced function

    if (this.state.activeTab === "first") {
    this.setState({
      searchActive: searchText,
      searchShipped: searchText,
    });
  }
  };

    render() {
      const { permissions } = this.props; 
      const hasAddOrderPermission = permissions && permissions['Customer Orders'] ? permissions['Customer Orders'].includes('Add Order') : false;

      debugger;
      console.log("Current searchQuery in state:", this.state.searchQuery);
      const columns = [

        {
          dataField: 'customerPoNumber',
          text: 'Order No.',
          sort: true,
          headerStyle: { minWidth: '200px', width: '200px' },
          //searchable: this.state.iscustomerpo,
          className: "text-truncate",
        },
        {
          dataField: 'customercode',
          text: 'Customer Code',
          sort: true,
          headerStyle: { minWidth: "200px", width: '200px' },
          className: "text-truncate",

          //searchable: this.state.iscustomercode,
        },
        {
          dataField: 'customerName',
          text: 'Customer Name',
          sort: true,
          //searchable: this.state.iscustomername,
          className: "text-truncate",
          headerStyle: { minWidth: "200px", Width: "200px" },

        },
        {
          dataField: 'orderDate',
          text: 'Order Date',
          sort: true,
          headerClasses: 'text-center',
          classes: 'text-center',
          headerStyle: { minWidth: "200px" },
          //searchable: this.state.isorderdate,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {/* {moment(row.orderDate).format("MM/DD/YYYY")} */}
                {row.orderDate}
              </EllipsisWithTooltip>
            );
          },
          sortFunc: (a: string, b: string, order: 'asc' | 'desc') => {
          const dateA = new Date(a); 
          const dateB = new Date(b);
          if (order === 'asc') {
            return dateA.getTime() - dateB.getTime();
          }
          return dateB.getTime() - dateA.getTime();
        },
        },

        // ,
        {
          dataField: 'totalAmount',
          text: 'Order Amount',
          headerClasses: 'text-end pe-4',
          classes: 'text-end pe-4 divgreen',
          headerStyle: { minWidth: "200px" },
          sort: true,
          searchable: false,
          //headerStyle: { width: '300px' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormat(row.totalAmount)}
              </EllipsisWithTooltip>
            );
          },
        },
       {
  dataField: 'status',
  text: 'Status',
  sort: true,
  headerStyle: { width: '200px' },
  headerClasses: 'text-end',
  classes: 'text-end',
  formatter: (cell: any, row: any, rowIndex: any) => {
    const status = row.status;
    let badgeContent:any = null;

    if (status === "Partially Shipped" || status === "SHIPPED,ACTIVE") {
      badgeContent = (
        <>
          <span className="badge badge-pill badge-primary color-green me-1">Active</span>
          <span className="badge badge-pill badge-primary color-red">Shipped</span>
        </>
      );
    } else {
      badgeContent = (
        <span
          className={
            status === "Active"
              ? "badge badge-pill badge-primary color-green"
              : "badge badge-pill badge-primary color-red"
          }
        >
          {status === "Not Started" ? "Open" : status}
        </span>
      );
    }

    return (
      <EllipsisWithTooltip placement="bottom">
        {badgeContent}
      </EllipsisWithTooltip>
    );
  },
       }

    

        // {
        //   dataField: 'status',
        //   text: 'Status',
        //   headerClasses: 'text-center',
        //   classes: 'text-center',
        //   sort: true,
        //   headerStyle: { minWidth: "100px" },
        //   searchable: this.state.isstatus,
        //   // headerStyle: { width: '700px' },
        // },


        // {
        //   dataField: '',
        //   text: '',
        //   headerClasses: 'text-center',
        //   classes: 'text-center',
        //   sort: false,

        //   searchable: this.state.isstatus,
        //   // headerStyle: { width: '700px' },
        // },



      ];

      const shippedColumns = [

        {
          dataField: 'customerPoNumber',
          text: 'Order No.',
          sort: true,
          headerStyle: { minWidth: '100px', width: '100px' },
          searchable: this.state.iscustomerpo,
          className: "text-truncate",
        },

        {
          dataField: 'customerCode',
          text: 'Customer Code',
          sort: true,
          headerStyle: { minWidth: "100px", width: '100px' },
          className: "text-truncate",
          searchable: this.state.iscustomercode,
        },
        {
          dataField: 'customerName',
          text: 'Customer Name',
          sort: true,
          searchable: this.state.iscustomername,
          className: "text-truncate",
          headerStyle: { minWidth: "200px", Width: "400px" },
        },
        {
          dataField: 'shipmentNo',
          text: 'Shipment No.',
          sort: true,
          headerStyle: { width: '200px' },
          searchable: this.state.iscustomerpo,
        },

        {
          dataField: 'shipmentDate',
          text: 'Shipment Date',
          sort: true,

          headerStyle: { minWidth: "100px" },
          searchable: this.state.isorderdate,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {moment(row.shipmentDate).format("MM/DD/YYYY")}
              </EllipsisWithTooltip>
            );
          },
        },

        
        {
          dataField: 'totalShippedQty',
          text: 'Shipped Qty',
          sort: true,
          searchable: this.state.totalShippedQty,
          headerStyle: { width: '200px' },
          headerClasses: 'text-center',
          classes: 'text-center',
          
        } ,
        {
          dataField: 'totalBoxNo',
          text: 'Total Box No',
          sort: true,
          searchable: this.state.isstatus,
          headerStyle: { width: '100px' },
          headerClasses: 'text-center',
      classes: 'text-center',
      
        },

      
        // ,
        {
          dataField: 'courierTrackingNo',
          text: 'Tracking No',
          headerStyle: { minWidth: "130px", width: '130px' },
          headerClasses: 'text-end',
          classes: 'text-end',
          sort: true,
          searchable: false,
          
          // formatter: (cell: any, row: any, rowIndex: any) => {
          //   return (
          //     <EllipsisWithTooltip placement="bottom">
          //       {row.courierTrackingNo}
          //     </EllipsisWithTooltip>
          //   );
          // },
        },



        // {
        //   dataField: '',
        //   text: '',
        //   headerStyle: { width: '100px' },
        // },

      
      ];

      const shippingColumns = [
        // {
        //   dataField: 'orderID',
        //   text: '#',
        //   headerStyle: { width: '10px' },
        // },
        {
          dataField: 'customerPoNumber',
          text: 'Order No.',
          sort: true,
          headerStyle: { width: '100px' },
          searchable: this.state.iscustomerpo,
        },
        {
          dataField: 'customercode',
          text: 'Customer Code',
          sort: true,
          headerStyle: { width: '100px' },
          searchable: this.state.iscustomercode,
        },
        {
          dataField: 'customerName',
          text: 'Customer Name',
          sort: true,
          searchable: this.state.iscustomername,
          // headerStyle: { width: '300px' },
        },


        {
          dataField: 'orderDate',
          text: 'Order Date',
          sort: true,

          headerStyle: { width: '100px' },
          searchable: this.state.isorderdate,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {moment(row.orderDate).format("MM/DD/YYYY")}
              </EllipsisWithTooltip>
            );
          },
        },

        // ,
        {
          dataField: 'totalAmount',
          text: 'Order Amount',
          headerClasses: 'amount',
          classes: 'text-end pe-4 divgreen',
          sort: true,
          searchable: false,
          headerStyle: { width: '200px' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormat(row.totalAmount)}
              </EllipsisWithTooltip>
            );
          },
        },

        {
          dataField: '',
          text: '',

          sort: false,
          searchable: false,
          headerStyle: { width: '100px' },

        },

        // {
        //   dataField: '',
        //   text: '',
        //   headerStyle: { width: '100px' },
        // },

        {
          dataField: 'status',
          text: 'Order Status',
          sort: true,
          searchable: this.state.isstatus,


          formatter: (cell: any, row: any, rowIndex: any) => {

            return (
              
              <>
            
              <EllipsisWithTooltip placement="bottom">
                
                  
    
                    <span className="badge badge-pill badge-primary color-green"> Active</span>
    
    
                </EllipsisWithTooltip>
          
          
                </>
    
            );


            // if (row.completeStatus == "Partial") {
            //   return (
            //     <div>
            //       <h6>
            //         {/* {row.status}  */}
                    
            //          <span className="badge badge-pill badge-primary color-orange">  ready to ship </span>
            //       </h6>
            //     </div>
            //   );
            // }
            // else {

            //   return (
            //     <div>
            //       <h6>
            //         {row.status}  <span className="badge badge-pill badge-primary color-green">  ready to {row.completeStatus.toLowerCase()} ship </span>
            //       </h6>
            //     </div>
            //   );
            // }

          }
        },


        // {
        //   dataField: 'Ship',
        //   text: '',
        //   sort: true,
        //   searchable: false,
        //   //headerStyle: { width: '300px' },
        //   formatter: (cell: any, row: any, rowIndex: any) => {


        //     return (
        //       <EllipsisWithTooltip placement="bottom">
        //         {<Button onClick={(x) => this.showShippingslideout(row)}>Ship</Button>}
        //       </EllipsisWithTooltip>
        //     );
        //   },
        // },

        {
          dataField: '',
          text: 'Action',


          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div className="btn-group">
                <Dropdown
                  onClick={(e) => { e.stopPropagation(); }}
                  className="more-action"
                  >
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary-white more"
                    id={"dropdown-more" + rowIndex}

                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey={"comments"} onClick={(x) => this.showShippingslideout(row)}>Ship </Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>
              </div>
            );
          },
        },
      ];

      const selectOptions = [{
        id: 0, column: 'Customer PO'
      },
      { id: 1, column: 'Customer Code' },
      { id: 2, column: 'Customer Name' },
      { id: 3, column: 'Order Date' },
      { id: 4, column: 'Status' },
      { id: 4, column: 'Shipment No' },
      { id: 4, column: 'Invoice No' },
      { id: 4, column: 'Tracking No' },
      ];

      const {

        showSlideout,
        showShippingSlideout,

      } = this.state;


      const expandSplitRow = {
        onlyOneExpanding: false,
        parentClassName: "parent-expand-foo",
        renderer: (row: any, rowIndex: any) => renderItemTableChild(row, rowIndex),
        showExpandColumn: true,
        // expandByColumnOnly: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }) => {
          if (isAnyExpands) {
            return <div></div>;
          }
          return <div></div>;
        },
        expandColumnRenderer: ({ expanded }) => {
          if (expanded) {
            return (
              <span className="chevronExpended">
                <img src={chevronRight} alt="chevron Right" />
              </span>
            );
          }
          return (
            <span className="chevronCollpsed">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        },
      };

      const renderItemTableChild = (mainrow, rowIndex) => {

        let splitDetail: any = [];
        splitDetail = this.state.shippingResult.filter(
          (x) => x.orderID === mainrow.orderID && x.rowType === 2
        );

        const columnCOAChild = [

          {
            dataField: "jobNo",
            text: "Job No.",
            classes: "expanding-bar",
            headerStyle: { minWidth: '100px', width: '100px' },
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (

                <EllipsisWithTooltip placement="bottom">
                  {row.jobNo}
                </EllipsisWithTooltip>
              );
            },
          },
          {
            dataField: "totalQty",
            text: "Total Qty",
            hidden: false,
            classes: "expanding-bar",
            headerStyle: { minWidth: '100px', width: '100px' },
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (
                <EllipsisWithTooltip placement="bottom">
                  {row.totalQty}
                </EllipsisWithTooltip>
              );
            },
          },
          {
            dataField: "shippingQty",
            text: "Remaining Qty",
            hidden: false,
            classes: "expanding-bar",
            headerStyle: { minWidth: '100px', width: '100px' },
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (
                <EllipsisWithTooltip placement="bottom">
                  {row.shippingQty}
                </EllipsisWithTooltip>
              );
            },
          },
          {
            dataField: "manualTracking",
            text: "Tracking",
            hidden: false,
            classes: "expanding-bar",
            headerStyle: { minWidth: '100px', width: '100px' },
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (
                <EllipsisWithTooltip placement="bottom">
                  {row.manualTracking ? 'Manual' : 'Tracked'}
                </EllipsisWithTooltip>
              );
            },
          },
          {
            dataField: "rowId",
            text: "rowId",
            hidden: true,
            classes: "expanding-bar",
            headerStyle: { minWidth: '500px', width: '500px' },
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (
                <EllipsisWithTooltip placement="bottom">
                  {row.rowId}
                </EllipsisWithTooltip>
              );
            },
          },
          {
            dataField: "",
            text: "",
            classes: "expanding-bar",
            headerClasses: "blankLastChildofChild",
            headerStyle: { minWidth: '500px', width: '500px' },
          },



        ];

        return (
          <>
            <div className='px-4 p-4'>
              <BootstrapTable
                id="tblCOAchild"
                keyField="rowId"
                data={splitDetail}
                columns={columnCOAChild}
                //rowEvents={this.rowEvents}
                selectRow={{
                  mode: 'checkbox', clickToSelect: false, hideSelectAll: false,
                  selected: splitDetail.filter((x) => x.selected === true).map(r => r.rowId),
                  onSelect: this.handleOnSelect,
                  onSelectAll: this.handleOnSelectAll,
                  hideSelectColumn: false,
                  selectColumnStyle: {
                    backgroundColor: '#5c82ab08'
                  },
                }}

              />
            </div>
          </>
        );
      };
      const customTotal = (from, to, size) => (
        <span className="text-muted">
          Showing {from} to {to} of {size} entries
        </span>
      );
      // const options = {
      //   // pageStartIndex: 0,
      //   sizePerPageList: [{
      //     text: '10', value: 10
      //   }, {
      //     text: '25', value: 25
      //   }, {
      //     text: 'All', value: this.state.searcResult.length
      //   }],
      //   showTotal: true,
      //   paginationTotalRenderer: customTotal,
      //   sizePerPage: 10,
      //   // hideSizePerPage: false,
      //   // hidePageListOnlyOnePage: false,
      // };
      const options = {

        showTotal: true,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [{
          text: '10', value: 10
        },
        {
          text: '25', value: 25
        },
        {
          text: '50', value: 50
        },

        {
          text: 'All', value: this.state.searcResult.length
        }] // A numeric array is also available. the purpose of above example is custom the text
      };


      
      return (
        <>
          <React.Fragment>






            <Container fluid className="body-sec" >
              <section>

                <div className="page-heading underline d-flex">

                  Customer Orders
                  {hasAddOrderPermission &&
                  <div className="action-group d-flex flex-row ml-auto">
                    <Button onClick={this.shownewslideout}
                    // className="btn-primary wht-bg link-btn mr-auto"
                    >Add Customer Order</Button>
                  </div>
                  }
                </div>


                <Tab.Container transition={false} 
                defaultActiveKey="first"
                activeKey={this.state.activeTab}
                onSelect={(k) => this.setState({ activeTab: k })}
                >

                  <section className="pb-3">
                    <Nav className="nav nav-underline border-bottom">
                      <Nav.Item className="nav-item">
                        <Nav.Link eventKey="first">All  Orders 
                          <span className="badge badge-light">{this.state.searcResult.length}</span>

                        </Nav.Link>
                      </Nav.Item>
                        <Nav.Item className="nav-item">
                          <Nav.Link eventKey="second">Active Orders
                            <span className="badge badge-light">
                    {this.state.shippingResult.filter(
                            (x) => x.rowType == 1
                          ).length}</span>

                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="nav-item">
                          <Nav.Link eventKey="third">Shipments
                            <span className="badge badge-light"> 
                  {this.state.shippedResult.length}</span>
                  
                          </Nav.Link>
                        </Nav.Item>
                    </Nav>
                  </section>

                  <Tab.Content>
                    <Tab.Pane eventKey="first">

                      <ToolkitProvider
                        keyField="id"
                        data={this.state.searcResult}
                        columns={columns}
                        //className="table table-striped table-borderless align-middle"
                        search
                      >
                        {
                          props => (


                            <div >
                              <section className="d-flex flex-wrap gap-3 pb-2">
                                <div className="position-relative">
                                  

                           <Form.Control
                              tabIndex={this.state.tabEnable}
                              id="txtSearch"
                              type="text"
                            placeholder="Search"
                              value={this.state.searchQuery}
                              onChange={this.onChangeHandler}
                              autoComplete="off"
                              className="w-full"
                            
                              title=""
                            />

                                </div>

                                <div
                                //className="input-group w-auto"
                                 className="col-12 col-md-2"
                                >
                                    <SingleDropdownListWithoutSearch

                                      itemList={this.state.selectOptions}
                                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                      defaultItem={this.state.selectedcolumn}
                                      defaultText={"Select Filter"}
                                      defaultName={this.state.selectedcolumn}
                                      controlID="1"
                                      id={"ddlselected"}
                                      key="id"
                                    />
                                </div>

                              </section>
                              <section className="pb-3">
                                <div className="table-responsive divbottom"  >
                                  <div className="ml-auto transactions-list payroll-tbl">
                                    <BootstrapTable
                                      {...props.baseProps}
                                      rowEvents={this.rowEvents}
                                      pagination={paginationFactory(options)}

                                    />
                                  </div>
                                </div>
                              </section>
                            </div>

                          )
                        }
                      </ToolkitProvider>



                    </Tab.Pane>
                    {/* <Tab.Pane eventKey="second">

                      <ToolkitProvider
                        keyField="id"

                        data={this.state.shippingResult.filter((x) => x.rowType === 1)}
                        columns={shippingColumns}
                        search
                      >
                        {
                          props => (


                            <div >
                              <section className="d-flex flex-wrap gap-3 pb-2">
                                <div className="position-relative">
                                  <SearchBar {...props.searchProps} />
                                </div>

                                <div
                                className="col-12 col-md-2"
                                >
                                    <SingleDropdownListWithoutSearch

                                      itemList={this.state.selectOptions}
                                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                      defaultItem={this.state.selectedcolumn}
                                      defaultText={"Select Filter"}
                                      defaultName={this.state.selectedcolumn}
                                      controlID="1"
                                      id={"ddlselected1"}
                                      key="id"
                                    />
                                </div>

                              </section>
                              <section className="pb-3">
                                <div className="table-responsive divbottom"  >
                                  <div className="ml-auto transactions-list">
                                    <BootstrapTable
                                      {...props.baseProps}
                                      keyField="rowId"
                                      rowEvents={this.rowEvents}
                                      pagination={paginationFactory(options)}
                                      expandRow={expandSplitRow}

                                    />
                                      {(this.state.footershow &&
                                  
                                  <div className="TabFooter-Pay"
                                  style={{ minWidth: "83.7%", width: "992px", maxWidth: "100%" }}
                                  >
                                    <div className="bulkSelectFooter">
                                     
                                      <div className="action-group d-flex flex-row mr-auto">
                                        <Button type="button"
                                        onClick={(x) => this.Shippingslideoutshow()}
                                        >Ship</Button>
      
                                        <Button type="button"
                                        className='space btn btn-primary btn-discard'
                                        onClick={(x) => this.discard()}
                                        >Discard</Button>
                                      </div>
                                    </div>
                                  </div>
                                      
      
                                )}
                                  </div>
                                </div>
                              </section>
                            </div>

                          )
                        }
                      </ToolkitProvider>

                    </Tab.Pane> */}
                       <Tab.Pane eventKey="second">
                  <ToolkitProvider
                    keyField="orderID"
                     data={this.state.shippingResult.filter((x) => x.rowType === 1)}
                        columns={shippingColumns}

                    search
                  >
                    {props => {
                      if (
                        this.state.activeTab === "first" &&
                        props.searchProps.searchText !== this.state.searchQuery
                      ) {
                        props.searchProps.onSearch(this.state.searchQuery);
                      }
                      return (
                        <div>
                          <section className="d-flex flex-wrap gap-3 pb-2">

                            <div className="position-relative">
                              <SearchBar
                                {...props.searchProps}
                                value={this.state.searchActive || ""}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  this.setState({ searchActive: val }, () => {
                                    props.searchProps.onSearch(val);
                                  });
                                }}
                              />
                              {props.searchProps.searchText && props.searchProps.searchText.trim() !== "" && (
                              <button
                                type="button"
                                className="btn-clear-search"
                                onClick={() => props.searchProps.onSearch("")}
                                title="Clear search"
                              >
                                ×
                              </button>
                            )}
                            </div>

                            <div className="col-12 col-md-2">
                              <SingleDropdownListWithoutSearch

                                      itemList={this.state.selectOptions}
                                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                      defaultItem={this.state.selectedcolumn}
                                      defaultText={"Select Filter"}
                                      defaultName={this.state.selectedcolumn}
                                      controlID="1"
                                      id={"ddlselected1"}
                                      key="id"
                                    />
                            </div>
                          </section>

                        
                          <section className="pb-3">
                            <div className="table-responsive1 divbottom">
                              <div className="ml-auto transactions-list expand-tbl">
                               <BootstrapTable
                                  {...props.baseProps}
                                  rowEvents={this.rowEvents}
                                  pagination={paginationFactory(options)}
                                    expandRow={expandSplitRow}
                                     rowClasses={(row, rowIndex) =>
                                  row.rowType == 1 ? "main-row" : "expand-row"
                                }
                                />
                              {(this.state.footershow &&
                                  
                                  <div className="TabFooter-Pay"
                                  style={{ minWidth: "83.7%", width: "992px", maxWidth: "100%" }}
                                  >
                                    <div className="bulkSelectFooter">
                                      {/* <span className="shift-selected-count">{this.state.selectedRows.length} */}
                                        {/* {" "}Selected</span> */}
                                      {/* <div className="FooterHorLine"></div> */}
                                      <div className="action-group d-flex flex-row mr-auto">
                                        <Button type="button"
                                        onClick={(x) => this.Shippingslideoutshow()}
                                        >Ship</Button>
      
                                        <Button type="button"
                                        className='space btn btn-primary btn-discard'
                                        onClick={(x) => this.discard()}
                                        >Discard</Button>
                                      </div>
                                    </div>
                                  </div>
                                      
      
                                )}
                              </div>
                            </div>
                          </section>
                        </div>
                      );
                    }}
                  </ToolkitProvider>
                </Tab.Pane>

                    {/* <Tab.Pane eventKey="third">


                      <ToolkitProvider
                        keyField="id"
                        data={this.state.shippedResult}
                        columns={shippedColumns}
                        className="table table-borderless align-middle"
                        search
                      >
                        {
                          props => (


                            <div >
                              <section className="d-flex flex-wrap gap-3 pb-2">
                                <div className="position-relative">
                                  <SearchBar {...props.searchProps} />
                                </div>

                                <div
                                className="col-12 col-md-2"
                                >
                                    <SingleDropdownListWithoutSearch

                                      itemList={this.state.selectOptions}
                                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                      defaultItem={this.state.selectedcolumn}
                                      defaultText={"Select Filter"}
                                      defaultName={this.state.selectedcolumn}
                                      controlID="1"
                                      id={"ddlselected2"}
                                      key="id"
                                    />
                                </div>

                              </section>
                              <section className="pb-3">
                                <div className="table-responsive divbottom"  >
                                  <div className="ml-auto transactions-list"  style={{ overflowX: 'hidden' }}>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      rowEvents={this.rowEvents}
                                      pagination={paginationFactory(options)}

                                    />
                                  </div>
                                </div>
                              </section>
                            </div>

                          )
                        }
                      </ToolkitProvider>


                    </Tab.Pane> */}
                       <Tab.Pane eventKey="third">
                  <ToolkitProvider
                   keyField="id"
                   data={this.state.shippedResult}
                   columns={shippedColumns}
                   className="table table-borderless align-middle"
                   search
                  >
                    {props => {
                      if (
                        this.state.activeTab === "first" &&
                        props.searchProps.searchText !== this.state.searchQuery
                      ) {
                        props.searchProps.onSearch(this.state.searchQuery);
                      }
                      return (
                        <div>
                          <section className="d-flex flex-wrap gap-3 pb-2">

                            <div className="position-relative">
                              <SearchBar
                                {...props.searchProps}
                                value={this.state.searchShipped || ""}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  this.setState({ searchShipped: val }, () => {
                                    props.searchProps.onSearch(val);
                                  });
                                }}
                              />
                              {props.searchProps.searchText && props.searchProps.searchText.trim() !== "" && (
                              <button
                                type="button"
                                className="btn-clear-search"
                                onClick={() => props.searchProps.onSearch("")}
                                title="Clear search"
                              >
                                ×
                              </button>
                            )}
                            </div>

                            <div className="col-12 col-md-2">
                               <SingleDropdownListWithoutSearch

                                      itemList={this.state.selectOptions}
                                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                      defaultItem={this.state.selectedcolumn}
                                      defaultText={"Select Filter"}
                                      defaultName={this.state.selectedcolumn}
                                      controlID="1"
                                      id={"ddlselected2"}
                                      key="id"
                                    />
                            </div>
                          </section>

                        
                          <section className="pb-3">
                            <div className="table-responsive divbottom">
                              <div className="ml-auto transactions-list payroll-tbl" style={{ overflowX: 'hidden' }}>
                               <BootstrapTable
                                  {...props.baseProps}
                                  rowEvents={this.rowEvents}
                                  pagination={paginationFactory(options)}
                                />
                             
                              </div>
                            </div>
                          </section>
                        </div>
                      );
                    }}
                  </ToolkitProvider>
                </Tab.Pane>

                  </Tab.Content>

                </Tab.Container>


                {/* <Tabs defaultIndex={0} onSelect={(index) => console.log(index)}
  
                  selectedTabClassName="is-selected" >
                  <TabList>
                  <section >

                      

                        <Tab>All  Orders<span className="badge badge-light">{this.state.searcResult.length}</span></Tab>


                        <Tab>Ready to Ship <span className="badge badge-light">{this.state.shippingResult.filter(
                          (x) => x.rowType == 2
                        ).length}</span>
                        </Tab>
                        <Tab>Shipped <span className="badge badge-light"> {this.state.shippedResult.length}</span>
                        </Tab>


                      



                    </section>

                  </TabList>



                  <TabPanel>


                    <ToolkitProvider
                      keyField="id"
                      data={this.state.searcResult}
                      columns={columns}
                      // className="table table-borderless align-middle"
                      search
                    >
                      {
                        props => (


                          <div >
                            <section className="d-flex flex-wrap gap-3 pb-3">
                              <div className="position-relative">
                                <SearchBar {...props.searchProps} />
                              </div>

                              <div 
                              //className="input-group w-auto"
                              >
                                <Form.Label>
                                  <SingleDropdownListWithoutSearch
                                    width="300px"
                                    itemList={this.state.selectOptions}
                                    handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                    defaultItem={this.state.selectedcolumn}
                                    defaultText={"Select Filter"}
                                    defaultName={this.state.selectedcolumn}
                                    controlID="1"
                                    id={"ddlselected"}

                                  /></Form.Label>
                              </div>

                            </section>
                            <section className="pb-3">
                              <div className="table-responsive ml-auto">
                                <BootstrapTable
                                  {...props.baseProps}
                                  rowEvents={this.rowEvents}
                                  pagination={paginationFactory(options)}

                                />
                              </div>
                            </section>
                          </div>

                        )
                      }
                    </ToolkitProvider>



                  </TabPanel>
                  <TabPanel>


                    <ToolkitProvider

                      data={this.state.shippingResult.filter((x) => x.rowType === 1)}
                      columns={shippingColumns}

                      search
                    >
                      {
                        props => (
                          <div>
                            <section className="d-flex flex-wrap gap-3 pb-3">
                              <div className="position-relative">
                                <SearchBar {...props.searchProps} />

                              </div>

                              <div 
                              //className="input-group w-auto"
                              >
                                <Form.Label>
                                  <SingleDropdownListWithoutSearch
                                    // tabIndex={this.state.tabEnable}
                                    itemList={this.state.selectOptions}
                                    handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                    defaultItem={this.state.selectedcolumn}
                                    defaultText={"Select Filter"}
                                    defaultName={this.state.selectedcolumn}
                                    cont
                                    rolID="1"
                                    id={"ddlselected"}
                                  //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
                                  // disabled={disable}
                                  /></Form.Label>

                              </div>
                            </section>
                            <section className="pb-3">
                              <div className="table-responsive">
                                <BootstrapTable id="tblShipping" className="table table-borderless align-middle"
                                  {...props.baseProps}
                                  keyField="rowId"
                                  rowEvents={this.rowEvents}
                                  expandRow={expandSplitRow}
                                  pagination={paginationFactory()}
                                />

                              </div>
                            </section>
                          </div>
                        )
                      }
                    </ToolkitProvider>

                  </TabPanel>
                  <TabPanel>


                    <ToolkitProvider

                      data={this.state.shippedResult}
                      columns={shippedColumns}

                      search
                    >
                      {
                        props => (
                          <div>
                            <section className="d-flex flex-wrap gap-3 pb-3">
                              <div className="position-relative">
                                <SearchBar {...props.searchProps} />
                              </div>

                              <div
                              // className="input-group w-auto"
                              >

                                <Form.Label>
                                  <SingleDropdownListWithoutSearch
                                    // tabIndex={this.state.tabEnable}
                                    itemList={this.state.selectOptions}
                                    handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                    defaultItem={this.state.selectedcolumn}
                                    defaultText={"Select Filter"}
                                    defaultName={this.state.selectedcolumn}
                                    controlID="1"
                                    id={"ddlselected"}
                                  //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
                                  // disabled={disable}
                                  /></Form.Label>
                              </div>
                            </section>
                            <section className="pb-3">
                              <div className="table-responsive">
                                <BootstrapTable id="tblShipped" className="table table-borderless align-middle"
                                  {...props.baseProps}
                                  keyField="rowId"
                                  rowEvents={this.rowEvents}
                                  // expandRow={expandSplitRow}
                                  pagination={paginationFactory()}
                                />
                              </div>
                            </section>
                          </div>
                        )
                      }
                    </ToolkitProvider>

                  </TabPanel>

                </Tabs> */}



                {(showSlideout &&
                  <Customerorderslideout
                    closeSlideOut={this.closeSlideOut}
                    orderid={this.state.orderid}
                  
                  >


                  </Customerorderslideout>
                )}



                {(showShippingSlideout &&
                  <ShippingSlideout
                    closeSlideOut={this.closeShippingSlideOut}
                    orderid={this.state.orderid}
                    jobids={this.state.jobIds}
                    shipmentId={this.state.shipmentId}
                  >


                  </ShippingSlideout>
                )}
              </section>
            </Container>



          </React.Fragment>
        </>
      );
    }
  }

  const mapStateToProps = (state) => ({
    permissions: state.PagePermissionReducer.permissions,
    locationId: state.LocationReducer.locationId 
  });

  export default connect(mapStateToProps)(Customerorder);